const APP_NUDGE_ENUMS = Object.freeze({
    SUCCESSFUL_INVESTMENT: 'successfulInvestment',
    INVESTOR_PROFILE: 'investorProfile',
    OPPORTUNITY_LISTING: 'opportunityListing',
});

export default APP_NUDGE_ENUMS;
